import React from 'react';
import TermsConditions from '../components/TermsConditions';

const TermsConditionsPage = () => {
  return (
    <main className="pt-20">
      <TermsConditions />
    </main>
  );
};

export default TermsConditionsPage;